import type { BetaFeatureDefinition } from '@/types/betaFeature';

/**
 * Every Dugout beta. Adding one is an entry here plus a matching
 * `dugout_beta_*` Config on the backend, which starts out hidden.
 *
 * Once a beta is released, delete its entry, its Config and the UI it replaced.
 */
export const BETA_FEATURES = {
  profileInsurance: {
    configKey: 'dugout_beta_profile_insurance',
    label: 'New Insurance panel',
    description: 'The redesigned Insurance panel on the Profile page.',
    ticket: 'AT-8779'
  }
} as const satisfies Record<string, BetaFeatureDefinition>;

export type BetaFeatureKey = keyof typeof BETA_FEATURES;

export const BETA_FEATURE_KEYS = Object.keys(BETA_FEATURES) as BetaFeatureKey[];
